export var ShowRoadDataCommand = function(eventArg) {
  this.showRoadData = eventArg;
}
ShowRoadDataCommand.prototype = {
  constructor: ShowRoadDataCommand,
  exec: function(vueScope) {
    if (this.showRoadData) {
      $('#RoadUnitData').show();
    } else {
      $('#RoadUnitData').hide();
    }
  }

}


// WEBPACK FOOTER //
// ./src/plugins/components/Web3dModels/commands/ShowRoadDataCommand.js